import isBrowser from '../isBrowser';
import type { Lucid } from '../../types/types';

const sendGoogleEvent = (event: Lucid.GoogleEvents.DataLayer) => {
  if (isBrowser()) {
    return window?.dataLayer?.push({
      event: event.name,
      ...event.data,
    });
  }

  return null;
};

export default sendGoogleEvent;
